module.exports = __webpack_public_path__ + "img/logo_login.22ec94b1.png";